var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box", attrs: { id: "base2bot" } },
    [
      _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "column" }, [
              _c(
                "div",
                [
                  _c("transition", { attrs: { name: "fade", appear: "" } }, [
                    _c(
                      "div",
                      { staticClass: "column" },
                      [
                        _c("MetricGraph", {
                          attrs: {
                            metrics: _vm.metrics,
                            name: "Numbers",
                            date: _vm.date,
                            period: _vm.period
                          },
                          on: { updateMetric: _vm.updateMetric }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "column" },
              [
                _c("transition", { attrs: { name: "fade", appear: "" } }, [
                  _vm.report.users && _vm.report.users.length > 0
                    ? _c("div", [
                        _c("div", { staticClass: "card" }, [
                          _c("h4", [
                            _vm._v("Humans"),
                            _c("span", { staticClass: "user-count" }, [
                              _vm._v(_vm._s(_vm.report.users.length))
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "dl",
                            [
                              _vm._l(_vm.report["users"], function(user) {
                                return [
                                  _c("dt", { key: user.user }, [
                                    _vm._v(_vm._s(user.user))
                                  ]),
                                  _c("dd", { key: user.user + user.count }, [
                                    _vm._v(_vm._s(user.count))
                                  ])
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade", appear: "" } }, [
                  _vm.report.contracts && _vm.report.contracts.length > 0
                    ? _c("div", [
                        _c("div", { staticClass: "card" }, [
                          _c("h4", { staticClass: "teams" }, [
                            _vm._v("Teams"),
                            _c("span", { staticClass: "contract-count" }, [
                              _vm._v(_vm._s(_vm.report.contracts.length))
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "dl",
                            [
                              _vm._l(_vm.report["contracts"], function(
                                contract
                              ) {
                                return [
                                  _c(
                                    "dt",
                                    {
                                      key: contract.contract,
                                      staticClass: "contracts",
                                      class: [
                                        {
                                          "hover-contract":
                                            _vm.hoverContract ==
                                            contract.contract
                                        },
                                        {
                                          "inactive-contract":
                                            _vm.hoverContract !=
                                            contract.contract
                                        }
                                      ],
                                      on: {
                                        mouseover: function($event) {
                                          _vm.hoverContract = contract.contract
                                        },
                                        mouseout: function($event) {
                                          _vm.hoverContract = null
                                        },
                                        click: function($event) {
                                          return _vm.updateContract(
                                            contract.contract
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(contract.contract))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "dd",
                                    {
                                      key:
                                        contract.contract +
                                        contract.count.toString()
                                    },
                                    [_vm._v(_vm._s(contract.count))]
                                  )
                                ]
                              })
                            ],
                            2
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "column" },
              [
                _c("transition", { attrs: { name: "fade", appear: "" } }, [
                  _vm.report.messages.length > 0
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "card",
                            class: [
                              {
                                positive:
                                  _vm.report.sentiment > _vm.sentimentThreshold
                              },
                              {
                                negative:
                                  _vm.report.sentiment < _vm.sentimentThreshold
                              }
                            ]
                          },
                          [
                            _c("h4", [_vm._v("Responsiveness")]),
                            _vm._v(" "),
                            _c("dl", [
                              _c("dt", [_vm._v("MTTA")]),
                              _c("dd", [
                                _vm._v(_vm._s(_vm.formatTime(_vm.report.mtta)))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "spacer" }),
                            _vm._v(" "),
                            _c("h4", [_vm._v("Sentiment")]),
                            _vm._v(" "),
                            _c("dl", [
                              _c("dt", [_vm._v("Score")]),
                              _c("dd", [
                                _vm._v(_vm._s(_vm.report.sentiment.toFixed(2)))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "spacer" }),
                            _vm._v(" "),
                            _vm.report.topics.length > 0
                              ? _c("h4", [_vm._v("Words")])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "dl",
                              [
                                _vm._l(_vm.report["topics"], function(topic) {
                                  return [
                                    _c("dt", { key: topic.topic }, [
                                      _vm._v(_vm._s(topic.topic))
                                    ]),
                                    _c(
                                      "dd",
                                      { key: topic.topic + topic.count },
                                      [_vm._v(_vm._s(topic.count))]
                                    )
                                  ]
                                })
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "transition-group",
              { attrs: { name: "list", appear: "" } },
              _vm._l(_vm.report["messages"], function(message) {
                return _c("div", { key: message.timestamp }, [
                  _c(
                    "div",
                    {
                      staticClass: "card",
                      class: [
                        { positive: _vm.sentimentPositive(message.sentiment) },
                        { negative: _vm.sentimentNegative(message.sentiment) },
                        { neutral: _vm.sentimentNeutral(message.sentiment) }
                      ]
                    },
                    [
                      _c("h5", [
                        _vm._v(_vm._s(message.user)),
                        _c("span", { staticClass: "timestamp" }, [
                          _vm._v(
                            _vm._s(
                              _vm.formatTimestamp(message.timestamp, _vm.period)
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(message.message))]),
                      _vm._v(" "),
                      message.ack_ts > 0
                        ? _c("div", { staticClass: "ack" }, [
                            _vm._v(
                              _vm._s(
                                _vm.calcAckTime(
                                  message.timestamp,
                                  message.ack_ts
                                )
                              )
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ])
              }),
              0
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7de3d5c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7de3d5c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Base2Bot.vue
// module id = null
// module chunks = 